import { render, staticRenderFns } from "./QuizzLayout.vue?vue&type=template&id=513b6fc1"
import script from "./QuizzLayout.vue?vue&type=script&lang=js"
export * from "./QuizzLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports